<div class="flex flex-row items-center w-full justify-between">
  <p>{{ '+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT' | translate }} {{ circuitId }}</p>
  <mat-slide-toggle
    #optimizedControlToggle
    gtm="onToggle"
    gtmAction="OBNG intelligent heat control toggle"
    gtmCategory="singleRoomControl"
    [disabled]="!optimizedControl?.commands?.setActive?.isExecutable"
    [checked]="optimizedControl?.properties?.active?.value"
    (change)="onToggleChange(optimizedControlToggle)"
  ></mat-slide-toggle>
</div>
